<template>
  <button @click="click" class="pbacklink pbacklink_new" :class="{'pbacklink_hidden':hidemode}" >
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="32" height="32" rx="16"/>
      <path d="M18 10L12.7071 15.2929C12.3166 15.6834 12.3166 16.3166 12.7071 16.7071L18 22" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/> </svg>
    <span class="pbacklink__text">Вернуться</span>
    </button>
</template>

<script>
import { mapState } from 'vuex';

  export default {
    data: ()=>({
      actions: {}
    }),
    props: {
      hidemode: {type: Boolean, default: false}
    },
    computed: {
      ...mapState(['step'])
    },
    methods: {
      click(e) {
        e.preventDefault()
        if (!this.hidemode) 
          this.$store.commit('prevStep')
      }
    }
  }
</script>

<style lang="sass">
.pbacklink
  display: flex
  align-items: center
  margin-top: 38px
  padding: 0
  margin-bottom: 32px
  color: colors.$newgray
  font-size: 14px
  line-height: 1.12
  letter-spacing: globalvars.$onespacing
  transition: opacity .2s ease-out
  &_hidden
    pointer-events: none
    opacity: 0
    cursor: auto
  &__text
    padding-top: 4px
  svg
    margin-right: 16px
    margin-top: 3px
    &, *
      transition: .3s ease-out
    rect
      fill: colors.$anothersilver
    path
      stroke: colors.$newgray

  @include for-mob
    margin-top: 5px
    margin-bottom: 32px
    svg
      margin-right: 3px
      margin-left: 0
      rect
        fill: transparent
    &__text
      display: none



</style>